// extracted by mini-css-extract-plugin
module.exports = {"styledDropdownMenu":"WlFvSf0d","prefixText":"SL4JbUun","optionWrapper":"ZHiAuZpM","label":"SddvpilJ","styledChip":"Uc9Q9faZ","styledOptionWrapperDisabled":"lafqjKu9"};